import React from "react";
import VideoComoSerAtendido from '../videos/atendimento-video.mp4';
import { useIsMobile } from "../hooks/useIsMobile";

export default function ComoSerAtendido() {
    const isMobile = useIsMobile();
    return (
        <div id="como-ser-atendidos" style={{ paddingTop: 60, paddingBottom: 120 }} className="como-ser-atendidos">
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginTop: 50,
                }}
                className="container"
            >
                <h1 className="chewy" style={{ fontSize: 40 }}>Como ser atendido(a)?</h1>
                <div className="kanchenjunga-regular">
                    {isMobile ? (
                        <p>
                            Para ser atendido no HOUFU, é preciso passar primeiro pela Unidade Básica de Saúde (UBS) do seu bairro para avaliação e possível encaminhamento. O HOUFU oferece atendimentos básicos e especializados em odontologia, integrando a Rede de Atenção à Saúde Bucal pelo SUS em Uberlândia. Em casos de urgência, como dores ou traumas, o Pronto Socorro Odontológico do Hospital de Clínicas da UFU atende 24 horas, sem necessidade de agendamento.

                        </p>
                    ) : (
                        <>
                            <p>
                                Para ser atendido(a) no HOUFU, é necessário comparecer à Unidade Básica de Saúde (UBS) mais próxima do seu bairro. Lá, a equipe irá avaliar a sua situação e verificar a possibilidade de encaminhamento para atendimento nas clínicas odontológicas da faculdade. O HOUFU desenvolve atividades clínicas vinculadas à Faculdade de Odontologia, em parceria com o Hospital Odontológico, e presta atendimentos à comunidade fazendo parte da Rede de Atenção à Saúde Bucal (RASB) do munícipio de Uberlândia por meio do Sistema Único de Saúde (SUS). Além dos atendimentos básicos em odontologia (limpezas, restaurações, extrações dentárias e outros), o HOUFU é um centro de referência regional para procedimentos especializados (próteses, tratamento de canal e outros).
                            </p>
                            <p>
                                Em casos de urgência e emergência, como: dores de origem dental, infecções odontogênicas, traumas dentais e faciais, hemorragias por trauma ou pós-cirúrgicas, entre outras, você pode procurar serviços odontológicos no Pronto Socorro Odontológico (PSO) que se encontra dentro do Hospital de Clínicas da Universidade Federal de Uberlândia, sem necessidade de agendamento prévio, que funciona 24 horas, todos os dias da semana.
                            </p>
                        </>
                    )}

                    <p className="atencao" style={{ textAlign: 'center', fontSize: 18 }}>
                        <b>Trouxemos um vídeo que explica passo a passo de como ser atendido(a).</b>
                    </p>
                </div>

                <div>
                    <video width="640" height="360" controls>
                        <source src={VideoComoSerAtendido} type="video/mp4" />
                        Seu navegador não suporta a tag de vídeo.
                    </video>
                </div>
            </div >
        </div >
    );
}